module.exports = __webpack_public_path__ + "static/media/logo.74efaed9.png";